import WebServiceRequest from '../Api/WebServiceRequest'

class GetAllSettings extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('StripeSettings')
  }
}

class GetCashbackSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('SiteSettings/GetCashBackDefaultPercantage')
  }
}

class UpdateCashbackSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')
    super.setTag('SiteSettings/UpdateBackDefaultPercantage')
  }

  setParams(data){
    super.setRequestParam(data)
  }
}
class GetBoosterProfitSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('SiteSettings/GetBoosterProfitPercentage')
  }
}

class UpdateBoosterProfitSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('SiteSettings/UpdateBoosterProfitPercentage')
  }

  setParams(data){
    super.setRequestParam(data)
  }
}

class CreateSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')
    super.setTag('StripeSettings')
  }

  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}

class UpdateSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('PUT')
    super.setTag('StripeSettings')
  }

  setParams(data) {
    super.setRequestParam(data)
  }

  setPayload(data) {
    super.setRequestParamDataObj(data)
  }
}

class DeleteSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('DELETE')
  }

  setParams(data) {
    super.setTag(`StripeSettings/${data.id}`)

  }
}
class GetGenericSettings extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('SiteSettings')
  }

  setParams(data){
    super.setRequestParam(data)
  }
}
class GetOptionValue extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('SiteSettings/GetSettingValue')
  }

  setParams(data){
    super.setRequestParam(data)
  }
}
class CreateGenericSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')
    super.setTag('SiteSettings/CreateSetting')
  }

  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}
class UpdateGenericSetting extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('PUT')
    super.setTag('SiteSettings/UpdateSetting')
  }

  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}
export {
  UpdateSetting,
  GetAllSettings,
  GetCashbackSetting,
  UpdateCashbackSetting,
  UpdateBoosterProfitSetting,
  GetBoosterProfitSetting,
  GetGenericSettings,
  GetOptionValue,
  CreateGenericSetting,
  UpdateGenericSetting

}
